export const messages = Object.freeze({
    ambiguous_role: 'Ambiguous role. Please be more specific.',
    blocked: 'This action is currently blocked. Contact support if you need help continuing.',
    connection_not_authorized: "You don't have permission to perform this action.",
    connection_not_requester: 'The connection is not requester.',
    creating_instances_with_single_editor_failed: 'The creating instances with single editor operation failed. Please try again or contact support.',
    deletion_request_reviewer_unauthorized: "You can't review this deletion request.",
    deletion_request_self_approval: "You can't approve your own deletion request.",
    email_already_invited: 'The email is already invited.',
    gid_is_none: 'A required value is missing. Refresh the page and try again.',
    illegal_valid_setting: 'Invalid valid setting. Please check your input.',
    instance_does_not_exist: 'The requested instance could not be found.',
    invalid_action: 'Invalid action. Please check your input and try again.',
    invalid_captcha_token: 'Invalid captcha token. Please check your input and try again.',
    invalid_email: 'Invalid email. Please check your input and try again.',
    invalid_email_domain: 'Invalid email domain. Please check your input and try again.',
    invalid_invgen_type: 'Invalid invitation link type. Please check your input and try again.',
    invalid_trial_extension: 'Invalid trial extension. Please check your input and try again.',
    invgen_not_exists: 'The requested invitation link could not be found.',
    invid_is_none: 'A required invitation value is missing from the request.',
    invitation_generator_invalid: 'Invalid invitation generator. Please check your input and try again.',
    invitation_not_valid: 'This invitation is no longer valid.',
    invitation_operation_invalid: 'Invalid invitation operation. Please check your input and try again.',
    invitation_send_failed: 'The invitation send operation failed. Please try again or contact support.',
    max_invocations_reached: 'The maximum number of invocations has been reached.',
    missing_org_parameters: 'Required organization information is missing. Refresh the page and try again.',
    name_collision_with_non_trial_space: 'A space with this name already exists.',
    no_iid_for_shared_instance_invgn: 'No instance for shared instance invgn was found or provided.',
    no_instance_editor_or_space_admin_role: 'No instance editor or space admin role was found or provided.',
    no_instance_found: 'No instance was found.',
    no_trial_creator: 'No trial creator was found or provided.',
    no_trial_creator_invitation_found: 'No trial creator invitation was found.',
    not_on_whitelist: 'This action is not allowed for your account.',
    not_recipient: 'You are not the recipient of this item.',
    not_trial_users: 'This is not available for trial users.',
    org_does_not_exist: 'The requested organization could not be found.',
    request_already_accepted: 'The request is already accepted.',
    request_already_rejected: 'The request is already rejected.',
    resource_pool_does_not_exist: 'The requested resource pool could not be found.',
    resource_pool_root_delete_forbidden: "You don't have permission to perform this action.",
    space_does_not_exist: 'The requested space could not be found.',
    token_is_none: 'A required token value is missing from the request.',
    trial_missing: 'The trial is missing or could not be found.',
    trial_not_found: 'The requested trial could not be found.',
    trid_is_none: 'A required value is missing. Refresh the page and try again.',
    unidentified_role: 'Your role could not be determined.',
    user_not_found_by_email: 'The requested user could not be found.',
    wrong_instance_short_id: 'Invalid instance name.',
    wrong_space_short_id: 'Invalid space name. Please check your selection and try again.'
})

export const dialogs = Object.freeze({
    already_accepting: {
        dialogTitle: 'Accepting invitation',
        dialogText: 'This invitation has already been accepted, please continue to wait a bit and reload the page after 1-2 minutes.',
        dialogAction: ['reload']
    },
    already_registering: {
        dialogTitle: 'Registering account',
        dialogText: 'Registration for this invitation has already been started, please continue to wait a bit and reload the page after 1-2 minutes.',
        dialogAction: ['reload']
    },
    invitation_has_expired: {
        dialogTitle: 'Invitation not valid!',
        dialogText: 'This invitation has expired or has been revoked.',
        dialogAction: ['dismiss']
    },
    invitation_revoked: {
        dialogTitle: 'Invitation not valid!',
        dialogText: 'This invitation has expired or has been revoked.',
        dialogAction: ['dismiss']
    },
    max_members_reached: {
        dialogTitle: 'Max users reached',
        dialogText: 'Trial has already reached the max user count, signup is not allowed.',
        dialogAction: ['returnToWelcomePage'],
        primaryAction: ['returnToWelcomePage']
    },
    max_spaces_reached: {
        dialogTitle: 'Max spaces reached',
        dialogText: 'Trial has already reached max space count, new space creation is not allowed.',
        dialogAction: ['returnToWelcomePage'],
        primaryAction: ['returnToWelcomePage']
    },
    trial_ended: {
        dialogTitle: 'Trial ended',
        dialogText: 'The trial end date has passed.',
        dialogAction: ['returnToWelcomePage'],
        primaryAction: ['returnToWelcomePage']
    },
    user_trial_expired: {
        dialogText: 'Your trial is up, cannot start applications anymore.',
        dialogTitle: 'Trial expired',
        dialogAction: ['contactSupport', 'returnToWelcomePage']
    }
})
